// selectors.ts
import { RootState } from '../store';

export const selectShowVideoThumbnail = (state: RootState): any => state.videoThumbnail.showVideoThumbnail;
